import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconMoreVertSvg } from "./IconMoreVertSvg.mjs";
const IconMoreVert = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconMoreVertSvg, ...iconProps });
};
export {
  IconMoreVert
};
